const recognitionGlobal = () => globalThis;
function browserLanguage() {
    if (typeof document !== 'undefined' && document.documentElement.lang) {
        return document.documentElement.lang;
    }
    if (typeof navigator !== 'undefined' && navigator.language)
        return navigator.language;
    return 'en-US';
}
export class Dictation {
    lang;
    static vendorNote = 'Browser dictation may send microphone audio to your browser vendor for transcription.';
    static isSupported() {
        const browser = recognitionGlobal();
        return Boolean(browser.SpeechRecognition ?? browser.webkitSpeechRecognition);
    }
    recognition;
    listeners = new Map();
    finalParts = [];
    started = false;
    ended = false;
    endRequested = false;
    finalEmitted = false;
    constructor(lang = browserLanguage()) {
        this.lang = lang;
    }
    on(event, listener) {
        const listeners = this.listeners.get(event) ?? new Set();
        listeners.add(listener);
        this.listeners.set(event, listeners);
        return () => listeners.delete(listener);
    }
    pressStart() {
        if (this.recognition)
            return;
        const browser = recognitionGlobal();
        const Constructor = browser.SpeechRecognition ?? browser.webkitSpeechRecognition;
        if (!Constructor) {
            this.emit('error', { code: 'unsupported', message: 'Browser dictation is unavailable.' });
            return;
        }
        this.finalParts = [];
        this.started = true;
        this.ended = false;
        this.endRequested = false;
        this.finalEmitted = false;
        const recognition = new Constructor();
        recognition.continuous = false;
        recognition.interimResults = true;
        recognition.lang = this.lang;
        recognition.onresult = (event) => this.handleResult(event);
        recognition.onerror = (event) => this.handleError(event.error);
        recognition.onend = () => {
            this.ended = true;
            this.recognition = undefined;
            if (this.endRequested)
                this.emitFinal();
        };
        this.recognition = recognition;
        recognition.start();
    }
    pressEnd() {
        if (!this.started || this.finalEmitted)
            return;
        this.endRequested = true;
        if (this.recognition)
            this.recognition.stop();
        else if (this.ended)
            this.emitFinal();
    }
    handleResult(event) {
        for (let index = event.resultIndex; index < event.results.length; index += 1) {
            const result = event.results[index];
            if (!result)
                continue;
            const text = result[0].transcript.trim();
            if (result.isFinal)
                this.finalParts.push(text);
            else
                this.emit('transcript', { kind: 'partial', text });
        }
    }
    handleError(error) {
        if (error === 'no-speech')
            return;
        if (error === 'not-allowed' || error === 'service-not-allowed') {
            this.emit('error', { code: 'mic_denied', message: 'Microphone permission denied.' });
            return;
        }
        this.emit('error', { code: 'dictation_error', message: `Dictation failed: ${error}` });
    }
    emitFinal() {
        if (this.finalEmitted)
            return;
        this.finalEmitted = true;
        this.emit('transcript', { kind: 'final', text: this.finalParts.filter(Boolean).join(' ') });
    }
    emit(event, value) {
        for (const listener of this.listeners.get(event) ?? [])
            listener(value);
    }
}
//# sourceMappingURL=dictation.js.map